// Contas do inventário de GEE. Tudo aqui é função pura: os dados chegam das
// coleções gee-emissao e gee-remocao (preenchidas pelo Apps
// Script), e a página só soma. Nenhum total é digitado no Squidex, para a
// tabela, os gráficos e o balanço nunca divergirem entre si.

export const numero = (v) => {
  const n = typeof v === 'number' ? v : Number(v);
  return Number.isFinite(n) ? n : 0;
};

export const toneladas = (n) =>
  numero(n).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// Squidex devolve { campo: { iv: valor } }; referência vem como lista de ids.
const iv = (item, campo) => item?.data?.[campo]?.iv;

export const lerEmissoes = (items = []) =>
  items
    .map((item) => ({
      ano: String(iv(item, 'ano') ?? ''),
      unidade: iv(item, 'unidade')?.[0] || '',
      escopos: ['escopo1', 'escopo2', 'escopo3'].map((c) => numero(iv(item, c))),
    }))
    .filter((l) => l.ano);

export const lerRemocoes = (items = []) =>
  items
    .map((item) => ({
      ano: String(iv(item, 'ano') ?? ''),
      unidade: iv(item, 'unidade')?.[0] || '',
      tipo: iv(item, 'tipo') || '',
      remocao: numero(iv(item, 'remocao')),
    }))
    .filter((l) => l.ano);

// As emissões vêm por ano e unidade; o inventário da cooperativa é a soma das
// unidades de cada ano.
export const emissoesPorAno = (linhas) => {
  const anos = {};
  linhas.forEach((l) => {
    const a = (anos[l.ano] = anos[l.ano] || { ano: l.ano, escopos: [0, 0, 0] });
    l.escopos.forEach((v, k) => {
      a.escopos[k] += v;
    });
  });
  return Object.values(anos)
    .map((a) => ({ ...a, total: a.escopos.reduce((s, v) => s + v, 0) }))
    .sort((a, b) => a.ano.localeCompare(b.ano));
};

export const anosDe = (linhas) => [...new Set(linhas.map((l) => l.ano))].sort();

export const somaRemocoes = (linhas) => linhas.reduce((s, l) => s + l.remocao, 0);
